const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: 'https://luke-cullen.netlify.app/',
  title: 'LC.',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'Luke Cullen',
  role: 'Software Engineer',
  picture: 'pf.png',

  description:
    'Currently a student at Aberystwyth University, I enjoy tackling challenging problems, optimizing performance, and creating clean, maintainable code. My projects range from tools for handling large datasets, often designed with usability and real-world impact in mind. I’m always exploring new technologies and approaches, aiming to combine strong engineering fundamentals with practical solutions.',
  resume: 'LukeCullencv2026.pdf',
  social: {
    linkedin: 'https://www.linkedin.com/in/luke-cullen-815859227/',
    github: 'https://github.com/lukec404',
  },
}

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    name: 'Major Project - Lightweight DSV Viewer',
    description: `This project is a delimiter-separated values (DSV) viewer designed to handle very large datasets that may exceed available system memory. It is currently implemented in Python due to the limited development timeframe of the university project. The viewer uses a chunking system to split large files into manageable segments and a sparse row indexer to allow fast random access to specific rows during scrolling and navigation. The project is still a work in progress, and after completing it for university I may explore porting the core components to a faster systems language such as C++ or Rust.`,
    stack: ['Python', 'Pytest'],
    start_data: '30/01/2026',
    end_data: 'preset',

    // sourceCode: 'https://github.com/LUKEC404/Lightweight-DSV-Viewer'
  },
  {
    image: '2048.png',
    name: '2048',
    description: `Implemented a browser-based clone of the 2048 puzzle game using JavaScript and CSS Grid. The project focuses on algorithmic tile merging, deterministic movement logic, and dynamic DOM rendering. Features include keyboard and WASD controls, score tracking, theme switching, and persistent game state.`,
    sourceCode: 'https://github.com/LUKEC404/2048',
    livePreview: 'https://lukec404.github.io/2048/',
    stack: ["HTML","CSS","JavaScript"],
  },
  {
    name: 'Minesweeper',
    description: 'A modern take on the classic Minesweeper, featuring a fully customizable grid where players can select the number of rows, columns, and mines. Players uncover tiles while avoiding hidden mines, with empty cells automatically revealing adjacent safe tiles for intuitive gameplay. The game emphasizes clean, interactive UI design and modular code, showcasing effective state management and dynamic grid rendering.',
    sourceCode: 'https://github.com/LUKEC404/Minesweeper',
    livePreview: 'https://lukec404.github.io/Minesweeper/',
    stack: ["HTML","CSS","JavaScript"],
  }
]

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'C',
  'C++',
  'Python',
  'JavaScript',
  'Java',
  'Git',
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'Lukecullen546@mail.com',
}

export { header, about, projects, skills, contact }
